export const environment = {
  production: false,
  API_URL: 'https://mdswebapiservicedev.azurewebsites.net',
  //API_URL: 'https://localhost:5001',
};

